import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { AuthProvider } from './hooks/useAuth'
import App from './App'

// Import styles (Tailwind + custom)
import './styles/index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

const theme = createTheme({
  palette: {
    primary: {
      main: '#c2a666',
    },
    secondary: {
      main: '#262626',
    },
    background: {
      default: '#f9f6f0',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Noto Sans", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Noto Serif", serif',
    },
    h2: {
      fontFamily: '"Noto Serif", serif',
    },
    h3: {
      fontFamily: '"Noto Serif", serif',
    },
    h4: {
      fontFamily: '"Noto Serif", serif',
    },
    h5: {
      fontFamily: '"Noto Serif", serif',
    },
    h6: {
      fontFamily: '"Noto Serif", serif',
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter basename="/admin">
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </QueryClientProvider>
    </AuthProvider>
  </React.StrictMode>,
)